'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, type ReactNode } from 'react';
import VaultDetailPageLayout from '../VaultDetailPageLayout';
import { VAULT_SECTION_CONFIG, VAULT_SUB_TAB_OPTIONS, type VaultSubTabs } from './useVaultSubTabState';
export interface VaultPageLayoutProps {
  simpleActionPanelSlot: ReactNode;
  heroSlot: ReactNode;
  overviewSlots: ReactNode;
  allocationSlots: ReactNode;
  performanceSlots: ReactNode;
  riskSlots: ReactNode;
  activitySlots: ReactNode;
  yourPositionSlots: ReactNode;
}
const VaultPageLayout = t0 => {
  const $ = _c(23);
  const {
    simpleActionPanelSlot,
    heroSlot,
    performanceSlots,
    riskSlots,
    activitySlots,
    overviewSlots,
    allocationSlots,
    yourPositionSlots
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== activitySlots || $[1] !== allocationSlots || $[2] !== heroSlot || $[3] !== overviewSlots || $[4] !== performanceSlots || $[5] !== riskSlots || $[6] !== simpleActionPanelSlot || $[7] !== yourPositionSlots) {
    const slots = {
      overview: overviewSlots,
      allocation: allocationSlots,
      performance: performanceSlots,
      risk: riskSlots,
      activity: activitySlots,
      yourPosition: yourPositionSlots
    };
    T0 = VaultDetailPageLayout;
    t1 = heroSlot;
    t2 = simpleActionPanelSlot;
    t3 = VAULT_SUB_TAB_OPTIONS;
    t4 = "vault-tabs";
    t5 = "overview-segment";
    t6 = VAULT_SECTION_CONFIG.map(section => ({
      ...section,
      slot: slots[section.id]
    }));
    $[0] = activitySlots;
    $[1] = allocationSlots;
    $[2] = heroSlot;
    $[3] = overviewSlots;
    $[4] = performanceSlots;
    $[5] = riskSlots;
    $[6] = simpleActionPanelSlot;
    $[7] = yourPositionSlots;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    T0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[15] !== T0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <T0 heroSlot={t1} simpleActionPanelSlot={t2} subTabOptions={t3} tabsTestId={t4} segmentId={t5} sections={t6} />;
    $[15] = T0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default memo(VaultPageLayout);